// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/1726030556/css/" + chunkId + "." + {"1427":"688249a2","1559":"ea454da8","1700":"19a60037","2202":"eb3e02c7","3563":"eb3e02c7","4560":"688249a2","7172":"19a60037","8265":"4c041c4d"}[chunkId] + ".chunk.css";
};